import { Inject, Injectable } from '@angular/core';
import { SignalRHubListener } from '@common/websocket/signal-r-hub-listener';
import { Observable, Subject } from 'rxjs';
import { serverToClientMessages } from '@common/const/server-to-client-messages';
import { environment } from '@/environments/environment';
import { Notifier, NOTIFIER } from '@shared/notifier/types';

@Injectable({
  providedIn: 'root'
})
export class PresentDeviceUsersUpdateListener extends SignalRHubListener {
  // eslint-disable-next-line @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match
  private _update$ = new Subject<undefined>();

  constructor(@Inject(NOTIFIER) notifier: Notifier) {
    super(
      environment.apiPaths.egituraPlatformApi + '/presentusershub',
      {
        incrementalRetryThresholdMS: 60 * 1000,
        name: 'presentusershub'
      },
      notifier
    );

    // Eén keer, in de constructor: vroeger stond dit in beforeConnecting, dat bij elke init en
    // elke herverbinding opnieuw loopt, zodat elke wijziging steeds meer herlaadbeurten gaf.
    this.hubConnection.on(serverToClientMessages.presentUsersHub.presentDeviceUsersChanged, () => {
      this._update$.next(undefined);
    });

    this.isAvailable$.subscribe(isAvailable => {
      if (isAvailable) {
        this._update$.next(undefined);
      }
    });
  }

  readonly update$: Observable<undefined> = this._update$;

  async stop(): Promise<void> {
    // Via close(): een bewuste stop mag niet als "verbinding verbroken" tellen.
    await this.close();
  }
}
